import { Component, Injectable } from "@angular/core";
import { MatDialog } from "@angular/material";
import "rxjs/add/observable/forkJoin";
import "rxjs/add/operator/switchMap";
import { AuthService } from "../../../authentication/services/auth.service";
import { AlertService } from "../../../shared/alert/services/alert.service";
import { ScheduledType } from "../../../shared/models/ScheduledContent";
import { ScheduleService } from "../../../shared/services/schedule.service";
import { SideBarService } from "../../../shared/services/sideBarService";
import { UrlService } from "../../../shared/services/url.service";
import { GlobalAlert, ScheduledGlobalAlert } from "../../models/globalalert";
import { GlobalAlertDeleteModalComponent } from "./globalAlertDeleteModal.component";
import { GlobalAlertMainComponent } from "./main.component";

@Component({
  selector: "app-globalalert-scheduled",
  templateUrl: "../templates/scheduled.component.html",
})
@Injectable()
export class GlobalAlertScheduledComponent extends GlobalAlertMainComponent {
  DashboardUrl: string;
  SelectedLanguageIsoCode: string;

  private scheduledGlobalAlerts: ScheduledGlobalAlert[] = [];

  private dialogStyle = {
    hasBackdrop: true,
    backdropClass: "fxstreet-modal-backdrop",
    panelClass: "fxstreet-message-dialog-panel",
    position: { top: "60px" },
  };

  constructor(
    private alertService: AlertService,
    private authService: AuthService,
    private dialog: MatDialog,
    private scheduledService: ScheduleService,
    private urlService: UrlService,
    sideBarService: SideBarService
  ) {
    super(sideBarService);

    this.DashboardUrl = this.urlService.GetDashboardRoute();
    this.SelectedLanguageIsoCode =
      this.authService.getActualLanguage().cultureNameISO;
  }

  ngOnInit() {
    this.initModel();
  }

  async initModel() {
    await this.loadScheduledGlobalAlert();
  }

  async loadScheduledGlobalAlert() {
    const response = await this.scheduledService
      .GetScheduleds<GlobalAlert>(ScheduledType.GlobalAlertMessage)
      .toPromise();

    if (response) {
      response.forEach((scheduled) => {
        if ((!scheduled.content.Culture && this.SelectedLanguageIsoCode === this.authService.defaultLanguage.cultureNameISO)
          || (scheduled.content.Culture === this.SelectedLanguageIsoCode))
        {
          const globalAlert = {
            id: scheduled.id,
            dateUtc: scheduled.dateUtc,
            content: scheduled.content,
          };
          this.scheduledGlobalAlerts.push(globalAlert);
        }
      });
    } else {
      this.alertService.removeAll();
      this.scheduledGlobalAlerts = [];
    }
  }

  deleteGlobalAlert(globalAlert: ScheduledGlobalAlert) {
    const deleteMessageDialog = this.dialog.open(
      GlobalAlertDeleteModalComponent,
      {
        ...this.dialogStyle,
        data: { message: globalAlert },
      }
    );

    deleteMessageDialog.componentInstance.itemDeleted.subscribe(
      (globalAlert: ScheduledGlobalAlert) =>
        this.handleMessageDeleted(globalAlert)
    );
  }

  private handleMessageDeleted(globalAlert: ScheduledGlobalAlert) {
    const messageIndex = this.scheduledGlobalAlerts.indexOf(globalAlert);
    this.scheduledGlobalAlerts.splice(messageIndex, 1);

    this.alertService.add("success", "Message deleted successfully");
  }

  public get globlaAlerts() {
    return this.scheduledGlobalAlerts;
  }
}



// WEBPACK FOOTER //
// ./src/app/editorialtools/components/scripts/scheduled.component.ts